import { render, staticRenderFns } from "./study-team.vue?vue&type=template&id=be7b297c&scoped=true&"
import script from "./study-team.vue?vue&type=script&lang=js&"
export * from "./study-team.vue?vue&type=script&lang=js&"
import style0 from "./study-team.vue?vue&type=style&index=0&id=be7b297c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7b297c",
  null
  
)

component.options.__file = "study-team.vue"
export default component.exports